// src/components/ui/HmongMotifIcon.js
import React from 'react';

const HmongMotifIcon = ({ size = 28, className = '' }) => (
  <svg viewBox="0 0 100 100" width={size} height={size} className={className}>
    <rect
      x="25"
      y="25"
      width="50"
      height="50"
      fill="none"
      stroke="white"
      strokeWidth="5"
      transform="rotate(45 50 50)"
    />
    <rect
      x="35"
      y="35"
      width="30"
      height="30"
      fill="none"
      stroke="white"
      strokeWidth="4"
      transform="rotate(45 50 50)"
    />
    <circle cx="50" cy="50" r="5" fill="white" />
    <circle cx="50" cy="20" r="4" fill="white" />
    <circle cx="50" cy="80" r="4" fill="white" />
    <circle cx="20" cy="50" r="4" fill="white" />
    <circle cx="80" cy="50" r="4" fill="white" />
  </svg>
);

export default HmongMotifIcon;
